import {LANGUAGE} from '@/common/utils/constants';

export const MANAGEMENT_STATUSES = {
	[LANGUAGE.en.short]: {
		step0: "Drafts",
		step1: "Submitted",
		step2: "Assigned",
		step3: "In Review",
		step4: "Validation",
		step5: "Approval",
		step7: "Approved",
		step8: "Published",
		step10: "Archived",
	},
	[LANGUAGE.it.short]: {
		step0: "bozze",
		step1: "Presentato",
		step2: "Assegnato",
		step3: "In revisione",
		step4: "Convalida",
		step5: "Approvazione",
		step7: "Approvato",
		step8: "Pubblicato",
		step10: "Archiviato",
	},
	[LANGUAGE.de.short]: {
		step0: "Entwürfe",
		step1: "Eingereicht",
		step2: "Zugewiesen",
		step3: "In Bewertung",
		step4: "Validierung",
		step5: "Die Genehmigung",
		step7: "Zugelassen",
		step8: "Veröffentlicht",
		step10: "Archiviert",
	},
	[LANGUAGE.fr.short]: {
		step0: "Brouillons",
		step1: "Soumis",
		step2: "Attribué",
		step3: "En revue",
		step4: "Validation",
		step5: "Approbation",
		step7: "Approuvé",
		step8: "Publié",
		step10: "Archivé",
	},
	[LANGUAGE.ja.short]: {
		step0: "ドラフト",
		step1: "提出",
		step2: "割り当て",
		step3: "レビュー",
		step4: "検証",
		step5: "承認",
		step7: "承認済み",
		step8: "公開",
		step10: "アーカイブ",
	},
	[LANGUAGE.es.short]: {
		step0: "Borradores",
		step1: "Enviado",
		step2: "Asignado",
		step3: "En revisión",
		step4: "Validación",
		step5: "Aprobación",
		step7: "Aprobado",
		step8: "Publicado",
		step10: "Archivado",
	},
}
